import React from "react";
import { getCodeProjects } from "../../actions/project";
import { connect } from "react-redux";
import { faBars, faPlus } from "@fortawesome/free-solid-svg-icons";
import { tempAlWait } from "../../helpers";
import AdminHeader from "../../components/AdminHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminHaut from "../../components/AdminHaut";
import AdminItemProject from "../../components/AdminItemProject";
import Alert from "../../components/Alert";

class AdminProject extends React.Component {
    state = {
        menuActive: false,
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        opts: [
            {
                type: 'link',
                ttl: "Créer un projet",
                ico: faPlus,
                link: "/admin/projects/ajout",
                action: null,
                col: null
            }
        ],
        datas: []
    }

    componentDidMount() {
        document.querySelectorAll('.dispAdmin').forEach(el => {
            el.style.display = "none";
        })
        document.getElementById('page').classList.add('pageWithout');

        if (this.props.canContinue) {
            this.props.getCodeProjects();
            this.setState({
                alert: tempAlWait()
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.getCodeProjects();
                this.setState({
                    alert: tempAlWait()
                });
            }
        }

        if (prevProps.redCdPrList != this.props.redCdPrList) {
            this.setState({
                alert: this.props.redCdPrList.alert,
                datas: this.props.redCdPrList.datas
            })
        }
    }

    render() {
        return <main className={`admin ${this.state.menuActive && "admin--active"}`}>
            <AdminHeader
                handleClose={(el) => this.setState({menuActive: el})}
                active={this.state.menuActive}
                changeAlert={(el) => this.setState({alert: el})}
                idtt={this.props.idtt}
            />
            {/** Bouton menu **/}
            <button
                title="Ouvrir le menu"
                aria-label="Ouvrir le menu"
                onClick={() => this.setState({menuActive: true})}
                className="adminHdr__btnOpen"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/** Header de page **/}
            <AdminHaut 
                ttl="Code - Les projets"
                options={this.state.opts}
            />
            
            {/** Données de la page **/}
            <div className="admin__ctnr">
                {
                    this.state.datas.length == 0 ?
                        <h2 className="admin__empty">Aucun projet n'a été créé pour le moment.</h2> :
                        <ul className="admin__list">
                            {
                                this.state.datas.map((data, key) => {
                                    return <AdminItemProject
                                        data={data}
                                        key={`project-${key}`}
                                        changeAlert={(alert) => {this.setState({alert: alert})}}
                                        refreshList={(doRefresh) => {
                                            if (doRefresh) {
                                                this.props.getCodeProjects();
                                            }
                                        }}
                                    />
                                })
                            }
                        </ul>
                }
            </div>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redCdPrList: state.redCdPrList
    }
}

const mapDispatchToProps = {
    getCodeProjects
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminProject);